<template>
    <!-- 结余出库明细 -->
    <div class="templete">
        <div class="search_box search_box_f no_print clearfix">
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-model="params.outstock_type" multiple placeholder="出库类型" filterable @visible-change="getStockDetailList('outstock_type')">
                <el-option v-for="list in selectMapC.outstock_type" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-model="params.bale_no" placeholder="捆包号"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-model="params.contract_no" placeholder="合同号"></el-input>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-model="params.breed_id" multiple collapse-tags placeholder="品名" filterable @visible-change="getStockDetailList('breed_id')">
                <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" filterable @visible-change="getStockDetailList('brand_id')">
                <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-model="params.index_thickness" multiple collapse-tags placeholder="厚度" filterable @visible-change="getStockDetailList('index_thickness')">
                <el-option v-for="(list,index) in selectMapC.index_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-model="params.index_length" multiple collapse-tags placeholder="长度" filterable @visible-change="getStockDetailList('index_length')">
                <el-option v-for="(list,index) in selectMapC.index_length" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getDetailList(true)" v-model="params.grade_id" multiple collapse-tags placeholder="等级" filterable @visible-change="getStockDetailList('grade_id')">
                <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="供单号"></el-input>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.opening_company_id" placeholder="货权单位" filterable @visible-change="getStockDetailList('opening_company_id')">
                <el-option v-for="list in selectMapC.opening_company_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getStockDetailList('supplier_id')">
                <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.attribute_id" multiple collapse-tags placeholder="属性" @visible-change="getStockDetailList('attribute_id')">
                <el-option v-for="list in selectMapC.attribute_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.color_id" multiple collapse-tags placeholder="选色" filterable @visible-change="getStockDetailList('color_id')">
                <el-option v-for="list in selectMapC.color_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.place_origin" placeholder="产地"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.expiry_time" placeholder="到期日"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.redemption_day" placeholder="赎单日"></el-input>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.category" placeholder="库存类型" filterable @visible-change="getStockDetailList('category')">
                <el-option v-for="list in selectMapC.category" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.container_no" placeholder="货柜号"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.storage_location" placeholder="库位号"></el-input>
            <el-input class="search_input search_inputBox" @keyup.enter.native="getDetailList(true)" v-if="isShowMore" v-model="params.remark" placeholder="备注"></el-input>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getDetailList(true)">查询</el-button>
                <div class="reset fcolor" style="margin: 0 20px;">
                    <el-checkbox v-model="dim_search">精确查找</el-checkbox>
                </div>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
         <div class="btnList clearfix">
            <div style="float: left;font-weight: 600;"> 出库仓库：{{balance.warehouse}}<span class="paddLeft"></span>出库月份：{{balance.stock_date}}</div>
        </div>
        <div class="tableBox no_print">
            <tabletem :isSetCol="true" :isLoading="tableLoading" :isShowIndex="true" :operationWidth="95" scene="stock.outstock.list" 
            :tablecol="tableCol" :tabledata="list"  @sortTable="sortTable" @relativefile="relativeFile" @getRow="getRow" @getTableDelete="getTableDelete" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalNumber" v-if="totalObj.original_cube||Number(totalObj.original_cube)===0">码单立方:{{totalObj.original_cube}}</div>
            <div class="totalNumber" v-if="totalObj.sales_cube||Number(totalObj.sales_cube)===0">销售立方:{{totalObj.sales_cube}}</div>
            <div class="totalNumber" v-if="totalObj.purchase_amount||Number(totalObj.purchase_amount)===0">码单金额:{{totalObj.purchase_amount}}</div>
            <div class="totalNumber" v-if="totalObj.sales_amount||Number(totalObj.sales_amount)===0">销售金额:{{totalObj.sales_amount}}</div>
            <div class="totalNumber" v-if="totalObj.cost_amount||Number(totalObj.cost_amount)===0">费用金额:{{totalObj.cost_amount}}</div>
            <div class="totalNumber" v-if="totalObj.warehouse_cost_amount||Number(totalObj.warehouse_cost_amount)===0">仓储费金额:{{totalObj.warehouse_cost_amount}}</div>
            <div class="totalNumber">选中件数: {{selectRow.length}}</div>
            <div class="totalNumber">选中立方: {{selectCube}}m³</div>
        </div>
        <div class="pageBox no_print">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="stock.outstock.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <el-dialog v-dialog-drag title="删除明细" :visible.sync="deleteDetailDialog" width="380px" class="eldialog cDiaC" :model="false">
            <!-- v-model="is_current_time " -->
            <el-checkbox 
                         class="confirmCheckBox" v-model="is_sync">是否确认删除并同步删除其他日期明细
            </el-checkbox>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="deleteDetail">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="deleteDetailDialog=false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog ref="deposit_params"  v-dialog-drag title="修改明细" :visible.sync="editDetailDialog" class="eldialog no_print eldialogLine auto" :modal="false" custom-class="full_dialog">
            <div style="display: flex;margin-left: 25px;">
            码单立方：<el-input v-model="cube" placeholder="" style="width:180px;"></el-input>
            </div>
            <el-checkbox 
                         class="confirmCheckBox" style="margin-left: 25px;"  v-model="is_sync">是否将此修改结果同步到其他日期明细
            </el-checkbox>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="editDetailDialog=!editDetailDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="editDetail">确定</el-button>
            </div>
        </el-dialog>
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isCanWidthEdit" :isHidePer="isHidePer" :ispost="ispost" :issetper="issetper" :widthSaleInventoryId="widthSaleInventoryId" :dialogvisible="dialogVisibleWidth" :type="widthObj.widthType" :widthid="widthObj.id" :list="widthObj.widthList" @changeSuccess="getDetailList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 销售宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="saleDialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isSaleCanEditTotalWidth" :dialogvisible="saleDialogVisibleWidth" :list="widthObj.widthList" @returnwidth="res=>{saleWidthReturn(res)}" :type="1"  @cancelWidth="()=>{this.saleDialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 销售宽度列表END -->
    </div>
</template>
<style scoped lang="scss">
.confirmCheckBox{margin-top: 20px;}
.dialogBtnList{margin-top: 20px;}
</style>
<script>
    import tabletem from '../../components/table.vue';
    import pagination from '../../components/pagination.vue';
    import relativeFile from '../../components/downloadRelativeFile.vue';
    export default {
        data(){
            return{
                module:localStorage.dw_erp_power_code,
                isShowMore:false,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    bale_no:"",
                    contract_no:"",
                    original_bale:"",
                    bill_lading_no:"",
                    place_origin:"",
                    container_no:"",
                    storage_location:"",
                    remark:"",
                    expiry_time:"",
                    redemption_day:"",
                    breed_id:[],
                    brand_id:[],
                    index_thickness:[],
                    index_length:[],
                    grade_id:[],
                    opening_company_id:[],
                    supplier_id:[],
                    attribute_id:[],
                    color_id:[],
                    outstock_type:[],
                    category:[],
                    dim_search:false,
                    page:1,
                    per_page:50
                },
                last_page:1,
                printLast_page:1,
                total:0,
                printTotal:1,
                selectRow:[],
                categoryList:[],
                selectMapC:{
                    outstock_type:[],
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    index_length:[],
                    index_thickness:[],
                    attribute_id:[],
                    color_id:[],
                    opening_company_id:[],
                    status:[],
                    bale_status:[],
                    category:[],
                },
                selectMap:{
                    port:[],
                    warehouse:[],
                    supplier:[],
                    breed:[],
                    brand:[],
                    grade:[],
                    attribute:[],
                    color:[],
                    saleBreed:[],
                    currency:[],
                },
                locationList:[],
                form_params_record:{},
                list:[],
                tableCol:[
                    {colName:"出库类型",colKey:"outstock_type_text",colWidth:75,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"检尺状态",colKey:"check_status_text",colWidth:75,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"入库日期",colKey:"inbound_date",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓储费单价",colKey:"warehouse_cost",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓储费金额",colKey:"warehouse_amount",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"库龄",colKey:"storage_age",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供单号",colKey:"original_bale",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"厚度",colKey:"index_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"长度",colKey:"index_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"码单方数",colKey:"original_cube",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"检尺方数",colKey:"check_cube",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"销售方数",colKey:"sales_cube",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"码单总宽",colKey:"original_width_total",colWidth:85,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true,isColor:true},
                    {colName:"销售总宽",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true,isColor:true},
                    {colName:"采购单价",colKey:"cube_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"币种",colKey:"foreign_currency_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"属性",colKey:"attribute",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"选色",colKey:"color",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"产地",colKey:"place_origin",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"板尺",colKey:"plate_ruler",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isHoverClick:true,isColor:true},
                    {colName:"汇率",colKey:"foreign_exchange_rate",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"费用平摊单价",colKey:"cost",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成本单价",colKey:"cost_price",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成本金额",colKey:"cost_amount",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售单价",colKey:"sales_price",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{},
                filterDialogVisible:false,
                filter:[],
                selectCube:0.0000,
                dim_search:false,
                deleteDetailDialog:false,
                editDetailDialog:false,
                edit_params:{},
                addDialogRules:[],
                order_id:'',
                balance:{},
                dialogVisibleWidth:false,
                saleDialogVisibleWidth:false,//销售总宽弹框
                isSaleCanEditTotalWidth:false,
                isCanWidthEdit:false,
                widthObj:{
                    id:"",
                    widthList:[],
                    widthType:2,//2.码单 3.销售
                },
                ispost:true,
                isHidePer:false,
                issetper:false,
                widthSaleInventoryId:"",
                selectData:{},
                is_sync:false,
                cube:"",
                month:'',
                warehouse_id:'',
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.order_id=sessionStorage.balanceDetail_ID;
            sessionStorage.removeItem("balanceDetail_ID");
            this.month=sessionStorage.monthData;
            sessionStorage.removeItem("monthData");
            this.warehouse_id=sessionStorage.warehouse_ID;
            sessionStorage.removeItem("warehouse_ID");
            this.getDetailList()           
        },
        methods:{
            relativeFile(obj){
                this.downLoadFileDialog = !this.downLoadFileDialog;
                if(obj.files!=null){
                    this.downFilesList = obj.files;
                }else{
                    this.downFilesList = '';
                }
            },
            exportExcelBill(){
                this.$exportExecl("/erp/stock.outstock.export","结余出库明细",this.params)
            },
            filterConfirm(){
                this.getDetailList()
            },
            getBillColumn(scene){
                this.postFunc("/erp/company.column.data",{scene:scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            //跳转成品明细
            openData(){
                sessionStorage.setItem("FINISHED_PRODUCT_DETAILS_ID",this.goodsId)
                this.$root.$children[0].$children[0].addTab({
                    name: '成品明细'+this.goodsId,
                    label: '成品明细',
                    content: 'warehouseRummageDetail'
                });
                this.dialogVisibles = false;
            },
            getStockDetailList(target){
                this.$getStockDetailList(target,this.params,2).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            addWidth(){
                this.widthObj.widthList.push(null)
            },
            delWidth(ind){
                 this.widthObj.widthList.forEach((item,index)=>{
                    if(index==ind){
                        this.widthObj.widthList.splice(index,1)
                    }
                 })
            },
            widthEdit(){
                let obj = new Object();
                obj.id=this.widthObj.id;
                if(this.widthObj.widthType==2){
                    obj.width=this.widthObj.widthList;
                }else{
                    obj.sales_width=this.widthObj.widthList;
                }
                this.postFuncLoading("/erp/inventory.update.width",obj,()=>{
                    this.tip('修改成功','success');
                    this.dialogVisibleWidth=false;
                    this.getDetailList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getTableEdit(id,row){
                this.selectData= row;
                this.cube = row.original_cube;
                this.editDetailDialog = true;
            },
            //修改确定
            editDetail(){
                let is_sync = this.is_sync==true?1:0;
                this.postFuncLoading("/erp/stock.detail.update",{order_id:this.order_id,inventory_id:[this.selectData.inventory_id],cube:this.cube,is_sync:is_sync},()=>{
                    this.tip('修改成功','success');
                    this.editDetailDialog = false;
                    this.getDetailList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            del(ids,row){
                this.selectData= row;
                this.deleteDetailDialog = true;
            },
            //删除明细
            deleteDetail(){
                let is_sync = this.is_sync==true?1:0;
                this.postFuncLoading("/erp/stock.detail.delete",{order_id:this.order_id,inventory_id:[this.selectData.inventory_id],is_sync:is_sync},()=>{
                    this.tip('删除成功','success');
                    this.deleteDetailDialog = false;
                    this.getDetailList()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            reset(){
                this.start_time=null;
                this.end_time=null;
                // this.start_out_time='';
                // this.end_out_time='';
                this.params=this.resetSearch(this.params)
                // this.params.check_status=999;
                // this.params.bale_status=[1];
                // this.is_like=false;
                this.getDetailList();
            },
            getDetailList(){
                // if(flag){
                //     this.params.page = 1;
                // }
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                // this.params.start_out_time=this.formatTimeZero(this.start_out_time);
                // this.params.end_out_time=this.formatTimeZero(this.end_out_time);
                this.params.dim_search = this.dim_search==true?1:0;
                if(this.order_id){
                    this.params.order_id=this.order_id;
                }else{//月结存
                    this.params.month = this.month;
                    this.params.warehouse_id = Number(this.warehouse_id);
                }                
                this.tableLoading = true;
                this.$postColumnList('/erp/stock.outstock.list',this.params,res=>{    
                    this.tableLoading = false;
                    this.list=res.data.data.list.data;
                    this.last_page=parseInt(res.data.data.list.last_page);
                    this.total=parseInt(res.data.data.list.total);
                    this.totalObj=res.data.data.total;
                    this.balance = res.data.data.info;
                    if(this.order_id){
                        this.balance.stock_date = this.formatTime(this.balance.stock_date+"000")
                    }
                    this.$refs.pagination.flag = true;
                    this.totalObj.original_cube=this.keepLimit(this.totalObj.original_cube)
                    this.totalObj.sales_cube=this.keepLimit(this.totalObj.sales_cube)
                    this.list.forEach((item,index)=>{
                        if(item.inbound_date!=0){
                            this.list[index].inbound_date = this.formatTime(item.inbound_date+"000")
                        }else{
                            this.list[index].inbound_date = "";
                        }
                        item.isEdit=item.isEdit==1?true:false;
                        item.isDelete=item.isDelete==1?true:false;
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                    })
                    this.continueFlag = true;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getPrintPage(obj){
                this.pint_params.page=obj.currentpage;
				this.pint_params.per_page=obj.pagesize;
            },
            rowClick(obj){
                 if (['original_width_total', 'sales_width_total'].includes(obj.name)) {
                    this.widthSaleInventoryId = this.widthObj.id = obj.id;
                    if (obj.name === "original_width_total") {
                        this.widthObj.widthType = 2;
                        this.widthObj.widthList = obj.row.width;
                        this.isHidePer = true;
                        this.issetper = false;
                    } else {
                        this.widthObj.widthType = 3;
                        this.widthObj.widthList = obj.row.sales_width;
                        this.isHidePer = false;
                        this.issetper = true;
                    }
                    this.isCanWidthEdit = false;
                    this.dialogVisibleWidth = true;
                }
            },
            getTableDelete(id,row){
                this.del([id],row)
            },
            //表格排序
            sortTable(sort){
                this.params.field = sort.order ? sort.prop:'';
                this.params.sort = sort.order == "ascending"?"asc":sort.order == "descending"?"desc":"";
                this.getDetailList();
            },
            getRow(row){
                this.selectRow=row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.sales_cube)
                })
                this.selectCube = this.keepLimit(number)
            },
        },
        components:{
            tabletem,
            pagination,
            relativeFile,
        },
        watch:{
            "params.page":function(){
                this.getDetailList();
            },
            "params.per_page":function(){
                this.getDetailList();
            },
            "pint_params.page":function(){
                this.printManage();
            },
            "pint_params.per_page":function(){
                this.printManage();
            },
            "deleteDetailDialog":function(val){
                if(!val){
                    this.is_sync = false;
                }
            },
            "editDetailDialog":function(val){
                if(!val){
                    this.is_sync = false;
                }
            },
        }
    }
</script>
